var _title, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHowSearch = function SvgHowSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 84 84"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Magnifying glass")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m56.719 52.407 5.06 5.06-4.49 4.49-5.06-5.061"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#8481E2",
    stroke: "#000",
    strokeWidth: 2,
    d: "M36.153 11c13.885 0 25.14 11.257 25.14 25.144s-11.255 25.144-25.14 25.144-25.14-11.258-25.14-25.144C11.013 22.257 22.269 11 36.153 11Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 2,
    d: "M49.5 49.497c-7.364 7.366-19.311 7.36-26.684-.013-7.374-7.375-7.378-19.324-.014-26.689s19.311-7.36 26.685.014 7.378 19.323.013 26.688Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD89E",
    stroke: "#000",
    strokeWidth: 2,
    d: "m60.115 66.27 6.156-6.157 5.454 5.455.707-.707-.707.707c1.7 1.7 1.7 4.457 0 6.157zm0 0 5.454 5.455c1.7 1.7 4.456 1.7 6.156 0z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#9BC6FF",
    stroke: "#000",
    strokeWidth: 2,
    d: "m56.332 62.487 6.156-6.157 2.369 2.369-6.156 6.157z"
  })));
};
export default SvgHowSearch;